<template>
  <div :class="$modal.fullWidth">
    <v-flex>
      <p :class="$modal.modalDangerText">
        {{ message }}
      </p>
    </v-flex>
    <slot/>
    <v-flex :class="$modal.modalDangerButtons">
      <BaseButton :class="[$modal.noBtn, $modal.descktopBtn]"
                  button-style="Cancel"
                  @click="cancel">
        {{ cancelText }}
      </BaseButton>
      <BaseButton :class="[$modal.dangerBtn, $modal.descktopBtn]"
                  button-style="Danger"
                  @click="confirm">
        {{ confirmText }}
      </BaseButton>
    </v-flex>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import BaseButton from '@/components/BaseButton';

/**
 * Component for generation content for confirmation modals
 * with two buttons (No, Yes)
 *
 * PROPS:
 * @prop {String} message - message for confirmation
 * @prop {String} confirmText - text for YES button
 * @prop {String} cancelText - text for NO button
 *
 * EVENTS:
 * cancel - when YES button clicked
 * confirm - when NO button clicked
 */
@Component({
  name:       'ConfirmModalContent',
  components: {
    BaseButton,
  },
  props: {
    message: {
      type:    String,
      default: 'Are you sure?',
    },
    confirmText: {
      type:    String,
      default: 'Yes',
    },
    cancelText: {
      type:    String,
      default: 'No',
    },
  },
})
export default class ConfirmModalContent extends Vue {
  cancel() {
    this.$emit('cancel');
  }

  confirm() {
    this.$emit('confirm');
  }
}
</script>

<style src="@/style/modals.scss" lang="scss" module="$modal"></style>



// WEBPACK FOOTER //
// src/components/ConfirmModalContent.vue